import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import Api from "../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../Services/Utils";
import { ACTIVITY_TYPE, HttpStatus } from "../../../../common/Constants";
import { autoPopulateCheckNosinResult } from "../../utils";

class TabDataUnitFJB extends Component {
  constructor(props) {
    super(props);
    this.state = {
      varianOptions: [],
    };
  }

  componentDidMount() {
    this.fetchDataVariant();
  }

  fetchDataVariant = async () => {
    const { setError } = this.props;
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllVariant,
      setError: setError,
      menuName: "Faktur Jual Bengkel - Data Unit",
      args: {},
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        varianOptions: res.data.data.map((d) => {
          return {
            label: `${d.kodeVariant} - ${d.namaVariant}`,
            value: d.kodeVariant,
            namaVariant: d.namaVariant,
          };
        }),
      }));
    }
  };

  fetchDetailNosin = async () => {
    const { onTriggerLoading, setError, formData, onTriggerAlert, onSetState } = this.props;
    const noMesin = formData?.dataUnit?.noMesin || "";

    const promises = [
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailNosinFjb,
        setError: setError,
        menuName: "Faktur Jual Bengkel - Data Unit",
        args: { nosin: noMesin },
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").getUserProfileByNoSin,
        setError: setError,
        menuName: "Faktur Jual Bengkel - Data Unit",
        args: { nosin: noMesin },
      }),
    ];

    onTriggerLoading();
    const [resultUnit, resultCustomer] = await Promise.all(promises);
    onTriggerLoading();
    if(!resultUnit?.data?.data){
      onTriggerAlert("Informasi", "Data tidak ditemukan pada CDB!")
    }
    const {customer: autoFilledCustomerData, unit: autoFilledUnitData} = autoPopulateCheckNosinResult({
      dataCustomer: resultCustomer?.data?.data || null,
      dataUnit: resultUnit?.data?.data || null,
      isCustomer: formData?.dataPemmbawa?.isBuyer,
      setValueCustomer: this.setValueCustomer,
      setValueUnit: this.setValue,
      setValueCarrier: this.setValueCarrier,
    });

    onSetState(prev=>({
      ...prev,
      autoFilledCustomerData,
      autoFilledUnitData
    }))
  };

  setValue = (name, value) => {
    const { onSetSpesificData } = this.props;
    onSetSpesificData("dataUnit", name, value);
  };

  setValueCustomer = (name, value) => {
    const { onSetSpesificData } = this.props;
    onSetSpesificData("dataPemilik", name, value);
  };
  
  setValueCarrier = (name, value) => {
    const { onSetSpesificData } = this.props;
    onSetSpesificData("dataPembawa", name, value);
  };

  render() {
    const { varianOptions } = this.state;
    const { formData, activityType, errors, isSO, isDirectSales, autoFilledUnitData } = this.props;
    const dataUnit = formData?.dataUnit || {};
    const isReadOnly = activityType === ACTIVITY_TYPE.VIEW || isSO || isDirectSales;
    const isMandatory = !isSO && !isDirectSales;

    return (
      <React.Fragment>
        <div className="grid grid-2x gap-20px grid-mobile-none">
          <div id="grid-1">
            <SimpleInput
              id="input_nomor_polisi"
              name="noPolisi"
              containerclassname="width width-full"
              label="Nomor Polisi"
              box="alphaNumeric"
              mandatory={isMandatory}
              errorMessage={errors?.dataUnit?.noPolisi}
              readOnly={isReadOnly}
              value={dataUnit?.noPolisi}
              onChange={({ target }) =>
                this.setValue(target.name, target.value)
              }
            />
            <SimpleInput
              id="input_nomor_rangka"
              name="noRangka"
              label="Nomor Rangka"
              mandatory={isMandatory}
              errorMessage={errors?.dataUnit?.noRangka}
              box="alphaNumeric"
              containerclassname="width width-full"
              value={dataUnit.noRangka}
              readOnly={isReadOnly || autoFilledUnitData?.noRangka}
              onChange={({ target }) =>
                this.setValue(target.name, target.value)
              }
            />
            <FlexView
              vAlignContent="center"
              style={{ justifyContent: "space-between", width: "100%" }}
            >
              <SimpleInput
                id="input_nomor_mesin"
                name="noMesin"
                containerclassname="width width-full"
                label="Nomor Mesin"
                value={dataUnit?.noMesin}
                mandatory={isMandatory}
                errorMessage={errors?.dataUnit?.noMesin}
                readOnly={isReadOnly}
                box="alphaNumeric"
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              <SimpleButton
                styles={{ marginTop: 10, width: "auto" }}
                text="CEK"
                secondary={isReadOnly}
                disabled={isReadOnly}
                onClick={() => this.fetchDetailNosin()}
              />
            </FlexView>
            <SimpleDDL
              id="select_options_kode_varian"
              name="kodeVarian"
              box="search"
              label="Kode Varian"
              mandatory={isMandatory}
              errorMessage={errors?.dataUnit?.kodeVariant}
              readOnly={isReadOnly || autoFilledUnitData?.kodeVarian}
              containerclassname="width width-full"
              options={varianOptions}
              value={dataUnit.kodeVarian}
              onChange={(value, { name }) => {
                this.setValue(name, value);
                this.setValue("namaVarian", value?.namaVariant);
              }}
            />
          </div>
          <div id="grid-2">
            <SimpleInput
              id="input_nama_varian"
              name="namaVarian"
              label="Nama Varian"
              containerclassname="width width-full"
              mandatory={isMandatory}
              errorMessage={errors?.dataUnit?.namaVariant}
              value={dataUnit?.namaVarian}
              readOnly
            />

            <SimpleInput
              id="input_tahun_motor"
              name="tahunMotor"
              label="Tahun Motor"
              readOnly={isReadOnly || autoFilledUnitData?.tahunMotor}
              box="onlyNumber"
              containerclassname="width width-full"
              value={dataUnit?.tahunMotor}
              onChange={({ target }) =>
                this.setValue(target.name, target.value)
              }
            />

            <SimpleInput
              id="input_informasi_bensin"
              name="informasiBensin"
              label="Informasi Bensin"
              box="onlyNumber"
              readOnly={isReadOnly || autoFilledUnitData?.informasiBensin}
              style={{ marginBottom: "12px" }}
              containerclassname="width width-full"
              value={dataUnit?.informasiBensin}
              onChange={({ target }) =>
                this.setValue(target.name, target.value)
              }
            />

            <SimpleInput
              id="input_km_terakhir"
              name="kmTerakhir"
              label="Km Terakhir"
              readOnly={isReadOnly || autoFilledUnitData?.kmTerakhir}
              box="onlyNumber"
              errorMessage={errors?.dataUnit?.kmTerakhir}
              containerclassname="width width-full"
              mandatory={isMandatory}
              value={dataUnit?.kmTerakhir}
              onChange={({ target }) =>
                this.setValue(target.name, target.value)
              }
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default TabDataUnitFJB;
